<template>
<div class="modal" :data-active="active">
  <div class="modal__content">

    <div class="modal__body">
      <div class="modal__header">
        <slot name="header"></slot>
      </div>
      <div class="modal__itemdetail">
        <slot name="itemdetail"></slot>
      </div>
      <slot name="content"></slot>
    </div>

    <div class="modal__footer">
      <div class="modal__close" @click="closeDialog">
        <button class="btn" data-color="pink_active">閉じる</button>
      </div>
    </div>

  </div>

  <div class="modal__backdrop" @click="closeDialog"></div>
</div>
</template>

<script>
export default {
  name: 'app-modal',
  props: {
    active: { type: Boolean, default: false },
    title: String,
    locationPath: String
  },
  methods: {
    closeDialog() {
      gtag('set', 'page_location', this.locationPath);
      this.$emit('close')
    }
  },
  watch: {
    active() {
      document.body.dataset.visibleDialog = this.active
    }
  }
}</script>

<style lang="scss">
body {
  &[data-visible-dialog="false"] { }
  &[data-visible-dialog="true"] { overflow: hidden; }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppModal.vue